import React from 'react'
import Raven from 'raven-js'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const styles = theme => ({
  snap: {
    border: '1px red dashed',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '9000'
    },
  p:  {
      margin: 0
    },
  img: {
    width: '100px',
      height: '100px'
  },
  message: {
      padding: '12px'
    }
})

const ErrorBoundaryFallbackComponent = ({classes, componentStack, error}) => (
    <div
      className={classes.snap}
      onClick={() => Raven.lastEventId() && Raven.showReportDialog()}
      >
      <p className={classes.p}>😱 Something's gone terribly wrong! 😱</p>
      <p className={classes.p}>Our team has been notified, but click {' '}
        <button  onClick={() => Raven.lastEventId() && Raven.showReportDialog()} >
          here
        </button>
        {' '} fill out a report.</p>
    </div>
);

export default withStyles(styles)(ErrorBoundaryFallbackComponent)



// WEBPACK FOOTER //
// ./src/errors/ErrorBoundaryFallbackComponent.js